module.exports = __webpack_public_path__ + "static/media/bylaws-white.ed223d01.svg";